<template>
  <v-container>
    <v-layout
      text-center
      wrap
    >
      <v-flex xs12>
        <v-img
          :src="require('../assets/top.png')"
          class="my-3"
          contain
          height="300"
        ></v-img>
      </v-flex>

      <v-flex xs12>
        <v-text-field
          solo
          label="検索ワードを入力してください"
          v-model="text"
        ></v-text-field>
      </v-flex>

      <v-flex mb-12>
        <v-row>
          <v-col cols="12" lg="6">
            <v-menu
              :close-on-content-click="false"
              max-width="290"
              v-model="satartMenu"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="formatDate(startDate)"
                  clearable
                  label="開始日"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="startDate"
                @change="satartMenu = false"
                locale="ja"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" lg="6">
            <v-menu
              :close-on-content-click="false"
              max-width="290"
              v-model="endMenu"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="formatDate(endDate)"
                  clearable
                  label="終了日"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="endDate"
                @change="endMenu = false"
                locale="ja"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </v-flex>

      <v-flex xs12>
        <v-col class="text-center">
          <div class="my-2" @click="search">
            <v-btn x-large color="primary">検索</v-btn>
          </div>
        </v-col>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'

export default {
  data: () => ({
    startDate: new Date().toISOString().substr(0, 10),
    endDate: new Date().toISOString().substr(0, 10),
    satartMenu: false,
    endMenu: false,
    text: "",
    excludeWords: [
      'amazon',
      '楽天',
      '食べログ',
      'naver',
      'pinterest',
      'メルカリ',
      'ハッシュタグ',
      'Tweet',
      '生年月日',
      'www.au.com',
      'www.nttdocomo.co.jp',
      'line.me',
      'jpn.pioneer',
      'goo.ne.jp'
    ]
  }),

  methods: {
    formatDate(date) {
      return date ? moment(date).format("YYYY/MM/DD") : ''
    },
    search() {
      if (!this.text) {
        alert("検索ワードを入力してください")
        return
      }
      const startDate = new Date(this.startDate)
      const endDate = new Date(this.endDate)
      // as_sitesearch=.com
      const googleUrl = `https://www.google.com/search?q=${this.text}&as_eq=${this.excludeWords.join('+')}&source=lnt&tbs=cdr:1,cd_min:${endDate.getMonth()}/${endDate.getDay()}/${endDate.getFullYear()},cd_max:${startDate.getMonth()}/${startDate.getDay()}/${startDate.getFullYear()}&tbm=blg"`
      window.open(encodeURI(googleUrl))
    },
  },
}
</script>
